
export enum VendorStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export enum SubscriptionPlan {
  FREE = 'free',
  PRO = 'pro'
}

export enum ManagementRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MODERATOR = 'moderator'
}

export enum UserRole {
  ADMIN = 'admin',
  OWNER = 'owner',
  USER = 'user'
}

export enum PromotionType {
  PRO_UPGRADE = 'pro_upgrade',
  VERIFIED_BADGE = 'verified_badge',
  EXTRA_ADS = 'extra_ads'
}

export enum ActivationRule {
  NEW_SIGNUP = 'new_signup',
  COUPON = 'coupon',
  MANUAL = 'manual'
}

export interface Promotion {
  id: string;
  name: string;
  benefit_type: PromotionType;
  benefit_value: number; // Ex: dias de pro ou qtd de anúncios
  activation_rule: ActivationRule;
  is_active: boolean;
  coupon_code?: string;
  category_id?: string;
  start_date?: string;
  end_date?: string;
  created_at: string;
}

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  whatsapp: string;
  password: string;
  role: ManagementRole;
  isActive: boolean;
}

export interface Neighborhood {
  id: string;
  name: string;
  is_airport_zone: boolean;
}

export interface Category {
  id: string;
  name: string;
  icon?: string;
}

export interface SystemConfig {
  maxAdsFree: number;
  maxAdsPro: number;
  supportWhatsapp: string;
  marketplaceName: string;
  marketplaceDescription: string;
  instagramUrl: string;
  youtubeUrl: string;
}

export interface VendorProfile {
  id: string;
  name: string;
  responsible: string;
  email: string;
  password: string;
  neighborhood_id: string;
  instagram: string;
  slug: string;
  bio: string;
  whatsapp: string;
  category_id: string;
  avatar_url: string;
  status: VendorStatus;
  plan: SubscriptionPlan;
  plan_expires_at?: string;
  verified_until?: string; // Novo campo para selo promocional
  rating: number;
  location: string;
  created_at: string;
  role: UserRole;
  email_verified: boolean;
}

export interface Ad {
  id: string;
  vendor_id: string;
  title: string;
  description: string;
  price: number | null;
  price_on_request: boolean;
  category_id: string;
  images: string[];
  tags: string[];
  is_active: boolean;
  clicks: number;
  views: number;
  created_at: string;
}

export interface MetricSnapshot {
  id: string;
  timestamp: string;
  total_vendors: number;
  total_pro_vendors: number;
  total_revenue: number;
  total_whatsapp_clicks: number;
}
